module.exports = __webpack_public_path__ + "static/media/visualstudio2019.7cf0cdfc.png";